import { render } from "./AutoScaleVmProfile.vue?vue&type=template&id=154f3306&scoped=true"
import script from "./AutoScaleVmProfile.vue?vue&type=script&lang=js"
export * from "./AutoScaleVmProfile.vue?vue&type=script&lang=js"

import "./AutoScaleVmProfile.vue?vue&type=style&index=0&id=154f3306&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154f3306"]])

export default __exports__